export const API_PATHS_TO_ELIMINATE_OPTIONS_CALL_FROM = [
  // flo checkout - exact path
  "/flo-checkout/api/attributes/v1/account-attributes",
  // kratos - dynamic checkout ID with specific rewards endpoint
  /\/kratos\/api\/v1\/checkout\/[^\/]+\/rewards/,
  /\/kratos\/api\/v1\/checkout\/[^\/]+\/upsell/,
  /\/kratos\/api\/v1\/checkout\/[^\/]+\/address\/[^\/]+\/etd/,
  // Example: any checkout endpoint with specific pattern
  // /^\/kratos\/api\/v1\/checkout\/[^\/]+\/discount$/,
  // Example: any path ending with specific suffix
  // /\/api\/v1\/.*\/analytics$/
];
